<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <bita-grid
            ref="grid"
            :columns="gridColumns"
            :read-data="readData"
            :grid-server-side="true"
            :schema-total="'total'"
            :schema-data="'data'"
            :server-paging="true"
            :batch="true"
            :resizable="true"
            :page-size="pageSize"
            :current-page="currentPage"
            :howRow="true"
          />
        </div>
      </bita-ibox>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        {
          title: "پشتیبانی",
          link: "support",
          active: true,
        },
      ],
      isLoadingGrid: false,
      filters: {},
      pageSize: 30,
      currentPage: 1,
      messages: [],
    };
  },
  computed: {
    gridColumns() {
      return [
        { title: "#", template: this.getTemplateID, width: "20px" },
        {
          field: "title",
          title: "عنوان",
          template: (e) => (e && e.title ? e.title : "-"),
          width: "120px",
        },
        {
          field: "full_name",
          title: "نام",
          template: (e) => (e && e.full_name ? e.full_name : "-"),
          width: "100px",
        },
        {
          field: "phone",
          title: "تلفن",
          template: (e) => (e && e.phone ? e.phone : "-"),
          width: "120px",
        },
        {
          field: "type",
          title: "نوع",
          template: (e) => this.getType(e),
          width: "80px",
        },
        {
          field: "text",
          title: "متن",
          template: (e) => (e && e.message ? e.message : "-"),
          width: "200px",
        },
        {
          field: "created_at",
          title: "زمان",

          template: (e) =>
            e && e.created_at ? this.$getJalaliDateTime(e.created_at) : "",
          width: "100px",
        },
        {
          title: "عملیات",
          width: "50px",
          command: this.gridCommands(),
        },
      ];
    },
  },
  methods: {
    getType(element) {
      let title = "";
      switch (Number(element.type)) {
        case 1:
          title = "تیکت";
          break;
        case 2:
          title = "نظر / انتقاد - پیشنهاد";
          break;
        case 3:
          title = "شکایت";
          break;
      }
      return title;
    },
    gridCommands() {
      let commands = [];

      commands.push({
        text: "delete",
        click: this.delete,
        template: this.gridButtons.delete,
      });
      return commands;
    },
    delete(e) {
      let ticket = this.$refs.grid.getSelectedGridRow(e);
      this.$alert("question", `آیا از حذف این پیام  اطمینان دارید ؟`, "", {
        confirmButtonText: "بله",
      }).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          this.$persistClient("delete", `support/tickets/${ticket.id}`)
            .then((res) => {
              this.$izitoast("success", "عملیات موفق", res.data.message);
              this.loadData();
            })
            .finally(() => {
              this.isLoadingGrid = false;
            });
        }
      });
    },
    getTemplateID() {
      return this.$refs.grid.getTemplateLocal();
    },
    readData(e) {
      this.pageSize = e.data.pageSize;
      this.currentPage = e.data.page;
      this.$resetGrid();
      this.isLoadingGrid = true;
      let baseUrl = `support/tickets?page=${this.currentPage}&page_size=${
        this.pageSize
      }&type=${this.filters.type_value || ""}`;
      let url = this.$makeQueryStringForSpatie(baseUrl, this.filters, "&");
      this.$persistClient("get", url)
        .then((res) => {
          e.success(res.data.data);
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },

    loadData() {
      this.$refs.grid.loadDataSource();
    },

    reset() {
      Object.keys(this.filters).forEach((key) => (this.filters[key] = ""));
      this.loadData();
    },
  },
};
</script>
